import { fuseFilter, nullOrUndefined } from '@/plugins/fuse'
import { SSharedList } from '@/services/shared'
import { mapGetters } from 'vuex'
import QUERY from 'lodash'

export default {
  data () {
    return {
      fetching: {
        activities: false
      },
      options: {
        activities: []
      },
      selected: {
        role: 2,
        activity: '',
        activityType: ''
      },
      editable: {
        activity: ''
      }
    }
  },

  computed: {
    ...mapGetters({
      currentUserRole: 'auth/user'
    })
  },

  methods: {

    async getActivities (context, search = '') {
      const selectedContext = context?.selected
      const fetchingContext = context?.fetching
      const optionsContext = context?.options

      if (nullOrUndefined(selectedContext) || nullOrUndefined(fetchingContext) || nullOrUndefined(optionsContext)) {
        throw Error('Invalid context object')
      }

      const activity = context.selected?.activity
      const role = context.selected?.role
      const activityType = context.selected?.activityType
      const fetching = context.fetching?.activities
      const options = context.options?.activities

      const contexts = [
        nullOrUndefined(activity),
        nullOrUndefined(role),
        nullOrUndefined(fetching),
        nullOrUndefined(options),
        nullOrUndefined(activityType)
      ]

      if (contexts.some(isInvalid => isInvalid)) {
        throw Error('Invalid context object')
      }

      context.fetching.activities = true
      context.selected.activity = ''

      const filters = {
        filter_text: search,
        activity_type: context.selected?.activityType || '',
        role_id: context.selected?.role?.id || context.selected?.role || ''
      }

      return await SSharedList.getActivities(filters).then(
        ({ data }) => {
          context.options.activities = data
        }
      ).catch(() => {
        context.options.activities = []
      }).finally(() => {
        context.fetching.activities = false
      })
    },

    async searchActivities (search, loading) {
      this.searchActivitiesProvider(this, search, loading)
    },

    searchActivitiesProvider: QUERY.debounce(
      ({ options, selected }, search, loading) => {
        const filteredOptions = fuseFilter(search, options.activities, {
          keys: ['activity_name']
        })

        if (filteredOptions.length < 1) {
          loading(true)

          const filters = {
            filter_text: search,
            activity_type: selected?.activityType || '',
            role_id: selected?.role?.id || selected?.role || ''
          }

          SSharedList.getActivities(filters).then(
            ({ data }) => {
              options.activities = data
            }
          ).catch(() => {
            options.activities = []
          }).finally(() => {
            loading(false)
          })
        }
      }, 500
    )
  }
}
